import { Text, TextProps, UnstyledButton } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { useSidebarMenu } from './MenuTriggerSlot';

type Props = TextProps & {
  children: ReactNode;
  'data-testid'?: string;
};

export function ClickableSectionTitle({ children, 'data-testid': testId, ...textProps }: Props) {
  const { open, isCollapsed } = useSidebarMenu({ customTrigger: true });

  if (isCollapsed) {
    const { style: incomingStyle, ...restTextProps } = textProps;
    return (
      <UnstyledButton
        onClick={open}
        aria-haspopup="dialog"
        data-testid={testId}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--mantine-spacing-xs)',
          minWidth: 0,
          padding: 0,
          textAlign: 'left',
          ...incomingStyle,
        }}
      >
        <IconChevronLeft size={20} color="var(--mantine-color-gray-8)" />
        <Text {...restTextProps} style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
          {children}
        </Text>
      </UnstyledButton>
    );
  }
  return (
    <Text {...textProps} data-testid={testId}>
      {children}
    </Text>
  );
}
